/**
 * @generated SignedSource<<d3e495ce13af29c2baddeabc50de9ca7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PlaylistPageRealmData$data = {
  readonly ancestors: ReadonlyArray<{
    readonly name: string | null | undefined;
    readonly path: string;
  }>;
  readonly isMainRoot: boolean;
  readonly name: string | null | undefined;
  readonly path: string;
  readonly " $fragmentType": "PlaylistPageRealmData";
};
export type PlaylistPageRealmData$key = {
  readonly " $data"?: PlaylistPageRealmData$data;
  readonly " $fragmentSpreads": FragmentRefs<"PlaylistPageRealmData">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PlaylistPageRealmData",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMainRoot",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Realm",
      "kind": "LinkedField",
      "name": "ancestors",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Realm",
  "abstractKey": null
};
})();

(node as any).hash = "a10ffe199556b22a2984564247b55fcb";

export default node;
